/**
 * Converts a number to a base64-encoded GraphQL cursor in a browser environment.
 * Assumes the cursor encodes the number with an offset (e.g., 1 → 'MA==', 2 → 'MQ==').
 * @param number The number to convert (1-based, e.g., 1, 2, 3).
 * @returns The base64-encoded cursor string.
 * @throws Error if the input is invalid.
 */
export function numberToCursor(number: number): string | null {
	if (number === 0) {
		return null;
	}

	// Validate input
	if (!Number.isInteger(number) || number < 1) {
		throw new Error('Number must be a positive integer');
	}

	try {
		// Apply offset (e.g., 1 → 0, 2 → 1) to match MA== → 1, MQ== → 2 pattern
		const adjustedNumber = number - 1;

		// Convert to string for base64 encoding
		const numberString = adjustedNumber.toString();

		// Encode to base64 using btoa (browser-compatible)
		return btoa(numberString);
	} catch (error) {
		throw new Error(`Failed to encode cursor: ${(error as Error).message}`);
	}
}
